'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

export default function HeaderActions() {
  const pathname = usePathname() || '';
  // Hooks must be called unconditionally
  const [copied, setCopied] = React.useState(false);
  // Render only inside room routes: /rooms/[roomName]
  const inRoom = /^\/rooms\/[A-Za-z0-9_.~%-]+/i.test(pathname);
  const copy = async () => {
    try {
      const url = window.location.href;
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // fallback
      try {
        const ta = document.createElement('textarea');
        ta.value = window.location.href;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
        setCopied(true); setTimeout(() => setCopied(false), 1500);
      } catch { }
    }
  };

  if (!inRoom) return null;

  return (
    <div style={{ marginLeft: 'auto' }}>
      <button
        onClick={copy}
        className="lk-button"
        title="Copiar link"
        style={{ padding: '6px 10px', background: 'green' }}
      >
        {copied ? 'Copiado!' : 'Copiar link'}
      </button>
    </div >
  );
}
